import axios from 'axios';

export default {
  getGroup(id) {
    return axios.get(`/v1/dynamic-approval/list-group/${id}`);
  },
  createApproval(data) {
    return axios.post('/v1/dynamic-approval/create-update', data);
  },
  detailApprover(params = {}) {
    return axios.get(`/v1/dynamic-approval/detail`, { params });
  },
  updateCondition(data) {
    return axios.put('/v1/dynamic-approval/condition/update', data);
  },
  deleteCondition(id) {
    return axios.delete(`/v1/dynamic-approval/condition/${id}`);
  },
  approveIO(data) {
    return axios.post('/v2/approve/io', data);
  },
  updateNotes(data) {
    return axios.put('/v2/reject/notes', data);
  },
  rejectIO(data) {
    return axios.post('/v2/reject/io', data);
  },
  approveGroupBO(data) {
    return axios.post('/v2/approve/group-bo', data);
  },
  rejectGroupBO(data) {
    return axios.post('/v2/reject/group-bo', data);
  },
  getBO(id) {
    return axios.get(`/v1/dynamic-approval/list-bo-group/${id}`);
  },
  approveHouse(data) {
    return axios.post('/v2/approve/house', data);
  },
  rejectHouse(data) {
    return axios.post('/v2/reject/house', data);
  },
  getConfigEmail() {
    return axios.get('/v2/email-schedule');
  },
  setConfigEmail(data) {
    return axios.post('/v2/email-schedule', data);
  }
};
